<div class="cardList">
  <div class="cardElement" *ngFor="let item of navigation" routerLink="{{ item.route }}">
    <!-- <davinci-icon *ngIf="item.icon" icon="{{ item.icon }}"></davinci-icon> -->
    <img class="image" [src]="item.image" />

    <h3 class="title">{{ item.label | translate }}</h3>
  </div>
</div>
